import { Application } from "../../../../Api";
import { ApplicationData, ApplicationDataInterface } from "../../ApplicationData";

export interface CustomApplicationDataInterface extends ApplicationDataInterface {
    salutation: string,
    dateOfBirth: Date | null,
    street: string,
    postalCode: string,
    city: string,
    handicap:string,
    certificateFiles: File[] | null,
    pid:string,
    it:string
}

export interface CheckboxFieldInterface {
    displayName: string,
    value: boolean,
    onChange: (e: any) => void,
}

export class CheckboxField implements CheckboxFieldInterface {
    displayName;
    value: boolean;
    onChange: (e: any) => void;

    constructor(displayName: string){
        this.displayName = displayName;
        this.value = false;

        this.onChange = (e: any) => {
            this.value = e.target.checked;
        }
    }
}

export class CustomApplicationData extends ApplicationData implements CustomApplicationDataInterface {
    salutation: string = "";
    firstName: string = "";
    lastName: string = "";
    emailAddress: string = "";
    phoneNumber: string = "";
    dateOfBirth: Date | null = null;
    street: string = "";
    postalCode: string = "";
    city: string = "";
    handicap:string="";
    cvFile: File | undefined = undefined;
    certificateFiles: File[] | null = null;
    additionalFiles: File[] | null = null;
    terms: boolean = false;
    // H.o.n.e.y.p.o.t
    name: string = "";
    email: string = "";
    pid:string="";
    it:string="";
    getApplication(tenant: string, jobId: string,jobList:string): Application {
        let application = super.getApplication(tenant, jobId,jobList);
        application.customProperties = [];
        application.customProperties.push(
            { name: "salutation", value: this.salutation },
            { name: "dateOfBirth", value: this.dateOfBirth?.toString() ?? "" },
            { name: "street", value: this.street },
            { name: "postalCode", value: this.postalCode },
            { name: "city", value: this.city },
            { name: "handicap", value: this.handicap }
        );

        return application;
    }
}
